// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"cc29a511","94":"cc29a511","405":"cc29a511"}[chunkId] + ".chunk.css";
};